import React from 'react'
import { InputNumber } from 'antd'
import { Controller, useFormState } from 'react-hook-form'

const ActiveNumberField = ({ field, control }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const input_style = field.input_design ? { ...field.input_design } : {}

  const error = errors[field.idFieldCanvas]
  let inputClass = ''

  if (isSubmitted) {
    inputClass = error ? 'input-error' : 'input-success'
  }

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      defaultValue={field.VALUE__reponse ? field.VALUE__reponse : ''}
      rules={{ required: field.required }}
      render={({ field: fieldProps }) => (
        <InputNumber
          className={inputClass}
          style={{ ...input_style }}
          placeholder={field.placeholder || ''}
          {...fieldProps}
        />
      )}
    />
  )
}

const InactiveNumberField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}

  return (
    <InputNumber
      style={{ ...input_style }}
      placeholder={field.placeholder || ''}
    />
  )
}

const NumberField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveNumberField field={field} control={control} />
  ) : (
    <InactiveNumberField field={field} />
  )
}

export default NumberField
